import { Input, Pill } from '@recruit-robin/robin-theme/web-components';
import { XClose } from '@recruit-robin/robin-theme/web-icons';
import { useState } from 'react';

import { useDictionary } from '@/shared/lib/i18n';
import { useInputRequirementStyles } from './InputRequirement.styles';

export type InputRequirementProps = {
  value?: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
};

export const InputRequirement = ({ value = [], onChange, placeholder }: InputRequirementProps) => {
  const classes = useInputRequirementStyles();
  const dictionary = useDictionary();
  const [inputValue, setInputValue] = useState('');

  const handleAddValue = () => {
    const safeValue = value ?? [];
    if (inputValue.trim() && !safeValue.includes(inputValue.trim())) {
      onChange([...safeValue, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleRemoveValue = (valueToRemove: string) => {
    const safeValue = value ?? [];
    onChange(safeValue.filter((v) => v !== valueToRemove));
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddValue();
    }
  };

  return (
    <Input
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyPress={handleKeyPress}
      placeholder={placeholder ?? dictionary.addMore}
      customCss={classes.input}
      startAdornment={
        (value ?? []).length > 0 ? (
          <div css={classes.pillsContainer}>
            {(value ?? []).map((selectedValue, index) => (
              <Pill
                key={`${selectedValue}-${index}`}
                label={selectedValue}
                style="icon-removable"
                type="subtle-light"
                endIcon={<XClose size={14} />}
                onClick={() => handleRemoveValue(selectedValue)}
              />
            ))}
          </div>
        ) : undefined
      }
    />
  );
};
